import React from 'react';
import { Modal } from 'antd';

class MessageModal extends React.Component {

    render() {
        return (
            <Modal title={this.props.title === undefined ? '消息' : this.props.title} visible={true} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} onCancel={this.props.onModalCancel}>
                {this.props.content}
            </Modal>
        );
    }

}

export default MessageModal;


// WEBPACK FOOTER //
// ./src/page/jsx/MessageModal.jsx